/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { GlobalAddressComponent } from './GlobalAddressComponent'
import type { ProfessionalAboutComponent } from './ProfessionalAboutComponent'
import type { ProfessionalExperienceComponent } from './ProfessionalExperienceComponent'
import type { ProfessionalUpdateEmailComponent } from './ProfessionalUpdateEmailComponent'
import type { ProfilingFilterTagComponent } from './ProfilingFilterTagComponent'
export type ProfessionalRequest = {
  data: {
    status: ProfessionalRequest.status
    address?: GlobalAddressComponent
    about?: ProfessionalAboutComponent
    experiences?: Array<ProfessionalExperienceComponent>
    tags?: Array<number | string>
    interests?: Array<number | string>
    user?: number | string
    maximumRadiusKm?: number
    interactions?: Array<number | string>
    lastUpdateEmail?: ProfessionalUpdateEmailComponent
    appointments?: Array<number | string>
    placements?: Array<number | string>
    candidate?: number | string
    filterTags?: Array<ProfilingFilterTagComponent>
    biNotes?: string
    finishedOnboarding?: boolean
    businessIntelligence?: BusinessIntelligenceBiReportingComponent
    messages?: Array<number | string>
    talentpools?: Array<number | string>
    referredBy?: Array<number | string>
    sentReferrals?: Array<number | string>
    currentJobTitle?: string
    searchSimilar?: boolean
    autoInteract?: boolean
    origin?: ProfessionalRequest.origin
  }
}
export namespace ProfessionalRequest {
  export enum status {
    ORIENTATING = 'orientating',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
  }
  export enum origin {
    SOCIAL_MEDIA_INSTAGRAM_AD = 'social_media_instagram_ad',
    SOCIAL_MEDIA_POST = 'social_media_post',
    VIA_FRIENDS_OR_FAMILY = 'via_friends_or_family',
    APPROACHED_BY_HEYU = 'approached_by_heyu',
    REFERRED_COMPANY = 'referred_company',
    GOOGLE_SEARCH = 'google_search',
    AI_SEARCH = 'ai_search',
    DONT_REMEMBER = 'dont_remember',
  }
}
